import { IndustryCompany } from "./industry-company.model";
import { IndustryProductDiscounts } from "./industry-product-discounts.model";

export class IndustryDiscount {
  constructor(
    private industryDiscountKey: IndustryDiscountKey,
    private company: IndustryCompany,
    private industryProductDiscounts: Array<IndustryProductDiscounts>,
    private created: string,
    private productCount: number,
  ) {}

  public getIndustryDiscountKey(): IndustryDiscountKey {
    return this.industryDiscountKey;
  }

  public getCompany(): IndustryCompany {
    return this.company;
  }

  public getIndustryProductDiscounts(): Array<IndustryProductDiscounts> {
    return this.industryProductDiscounts;
  }

  public getCreated(): string {
    return this.created;
  }

  public getProductCount(): number {
    return this.productCount;
  }

  public setIndustryDiscountKey(value: IndustryDiscountKey) {
    this.industryDiscountKey = value;
  }

  public setCompany(value: IndustryCompany) {
    this.company = value;
  }

  public setIndustryProductDiscounts(value: Array<IndustryProductDiscounts>) {
    this.industryProductDiscounts = value;
  }

  public setCreated(value: string) {
    this.created = value;
  }

  public setProductCount(value: number) {
    this.productCount = value;
  }
}

export class IndustryDiscountKey {
  constructor(private value: string) {}

  public getValue(): string {
    return this.value;
  }

  public setValue(value: string) {
    this.value = value;
  }
}
